module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAABgYGBoaGhlZWVlZWVkZGRlZWVlZWVlZWVlZWVmZmZmZmZlLfXtAAAAC3RSTlMAECAwP0BgkMDg8LbnKEcAAABMSURBVAjXY2DAAEwuYKDAUL0bDLYz7IYChm4IvYNBCsKYyMC8GkTvMmBgsAIxFgP1s4IYBiCTsnfv3gY2km337gSI4dnbYLYoMGADAGPnKP2sxawDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgnew/arrow-d-g.png
// module id = jc9V
// module chunks = 1